export default __webpack_public_path__ + "static/media/vuenosaires_polygon.39a22d64.png";